<div class="pagebg">
  <div class="banner-image">
    <div class="banner-text">
      <h2>{{"Pacotes" | translate}}</h2>
    </div>
  </div>
  <div class="container">
    <div class="row m-3">
      <div class="col-md-4" id="searchText">
        <h5>{{"Selecione seu pacote" | translate }}</h5>
      </div>

      <div class="col-md-8 d-flex justify-content-end" id="searchText">
        <div class="col-md-6 row flex-row">
          <div class="col-md-8">
            <select class="form-control" [(ngModel)]="DestinoId" style="color: gray">
              <option [ngValue]="0" selected>{{ DestinoId != 0 ? "Todos" : "Selecione um Destino" | translate | titlecase}}</option>
              <option *ngFor="let d of Destinos" [ngValue]="d.Id">
                {{ d.Descricao | titlecase }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <button (click)="buscarPacoteDestino(DestinoId)" class="btn btn-search" type="button" id="button-addon2">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4 search-box">
        <input type="text" class="form-control" placeholder="Pesquisar" id="search-area" [(ngModel)]="parametroBusca"/>
        <div class="input-group-append">
          <button (click)="buscarPacotesLst()" class="btn btn-search" type="button" id="button-addon2">
            <i class="fas fa-search"></i>
          </button>
        </div>
      </div> -->
    </div>

    <div *ngIf="loading">
      <app-view-loading></app-view-loading>
    </div>

    <div class="card-section mb-5" *ngIf="!loading">
      <div class="card" *ngFor="let pacote of Pacotes; let i = index">
        <img src="{{ pacote.imagemPrincipal != '' ? pacote.imagemPrincipal : backgroundimage}}" class="card-img-top">
        <div class="card-body">
          <div class="row">
            <div class="col zeroPaddingMargin">
              <h6 class="card-subtitle text-muted">{{ pacote.Cidade.Nome }}</h6>
            </div>
            <div class="col duration">
              <span class="duration">{{ pacote.MinimoDeNoites }} {{"Noite" | translate}}(s)</span>
            </div>
          </div>
          <h5 class="card-title">
             {{idioma == 'es' && pacote?.Nome_Es ? pacote?.Nome_Es :
                  idioma == 'en' && pacote?.Nome_En ? pacote?.Nome_En :
                  pacote?.Nome }}
            </h5>


          <div class="card-bottom">
            <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#detailsModal"
              (click)="PacoteDetalhes = pacote">
              {{"Detalhes do pacote" | translate}}
            </button>
            <button class="btn btn-search" type="button" (click)="abrirModal(pacote, contentHotelDetalhes)">
              {{"Selecionar" | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></app-paginacao>
  </div>
</div>

<div class="modal fade bd-example-modal-lg" tabindex="-1" id="detailsModal" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{"Detalhes do pacote" | translate}}
        </h5>
        <i type="button" class="btn btn-search" data-bs-dismiss="modal" class="fas fa-times"></i>
      </div>
      <div class="modal-body">
        <div class="container">

          <div>
            <!-- <img [src]="PacoteDetalhes?.PacoteImagens[0]?.Imagem" class="img-fluid card-img-top" -->
            <img [src]="PacoteDetalhes?.imagemBanner" class="img-fluid card-img-top"
              style="max-height: 500px; object-fit: fill" [alt]="PacoteDetalhes?.Nome" />
          </div>
          <div class="p-2">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation"
                *ngFor="let inclui of PacoteDetalhes?.PacotesInclui; let i = index">
                <button class="nav-link" [ngClass]="i == 0 ? 'active' : ''" id="tabs{{i}}" data-bs-toggle="tab"
                  [attr.data-bs-target]="'#tab' + i" type="button" style="text-decoration: none !important;" role="tab"
                  [attr.aria-controls]="'tab' + i" [attr.aria-selected]="i == 0 ? true : false">
                  {{idioma == 'es' && inclui?.Titulo_Es ? inclui?.Titulo_Es :
                    idioma == 'en' && inclui?.Titulo_En ? inclui?.Titulo_En :
                    inclui?.Titulo
                  }}
                </button>
              </li>
            </ul>
            <div class="tab-content p-2 mt-2" id="myTabContent">
              <div *ngFor="let inclui of PacoteDetalhes?.PacotesInclui; let i = index" class="tab-pane fade"
                id="tab{{i}}" [ngClass]="i == 0 ? 'show active' : ''" role="tabpanel"
                [attr.aria-labelledby]="'tabs' + i" [innerHTML]="idioma == 'es' && inclui?.Descritivo_Es ? inclui?.Descritivo_Es :
                      idioma == 'en' && inclui?.Descritivo_En ? inclui?.Descritivo_En :
                      inclui?.Descritivo"></div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-search" data-bs-dismiss="modal">
            {{"Voltar" | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


  <ng-template #contentHotelDetalhes let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{"Detalhes do pacote" | translate}}
        </h5>
        <i type="button" class="btn btn-search" data-bs-dismiss="modal" class="fas fa-times"
          (click)="fecharModal()"></i>
      </div>
      <div class="modal-body">
        <div class="container" *ngFor="let trecho of busca.trechos; let i = index">
          <div class="row dateInput justify-content-start">

            <div class="form-datepicker col-md-3" *ngIf="Pacote.PacotePeriodos.length == 0">
              <mat-form-field class="datepicker w-100" appearance="fill">
                  <mat-label>{{ "Entrada" | translate }}</mat-label>
                  <input matInput [matDatepicker]="pickerIda" [(ngModel)]="trecho.dataIda"
                      (dateChange)="setDataIda($event.value, busca.trechos, i)"
                      [min]="minDate" [max]="maxDate" autocomplete="off" readonly />
                    <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                  <mat-datepicker-toggle matSuffix [for]="pickerIda"></mat-datepicker-toggle>
                  <mat-datepicker #pickerIda></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-datepicker col-md-3 mt-md-1" *ngIf="Pacote.PacotePeriodos.length > 0">
              <mat-form-field class="datepicker w-100" appearance="fill">
                <mat-label>{{"Entrada" | translate}}</mat-label>
                <input matInput [matDatepicker]="pickerIda" [matDatepickerFilter]="myFilterData" [(ngModel)]="trecho.dataIda"
                    (dateChange)="setDataIda($event.value, busca.trechos, i)"
                    [min]="minDate" [max]="maxDate" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="pickerIda"></mat-datepicker-toggle>
                <mat-datepicker #pickerIda></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <span class="input-group-text" id="inputGroup-sizing-default">{{ "Noites" | translate }}</span>
              <select class="form-control align-self-end" disabled>
                <option value="{{busca.nrnoites}}">{{busca.nrnoites + ' Noites' | translate}}</option>
              </select>
            </div>

            <div class="form-datepicker col-md-3">
              <mat-form-field class="datepicker w-100" appearance="fill">
                  <mat-label>{{ "Saída" | translate }}</mat-label>
                  <input matInput [matDatepicker]="pickerVolta" [min]="trecho.dataIda ? (trecho.dataIda.plus ? trecho.dataIda.plus({ days: Pacote.MinimoDeNoites }) : trecho.dataIda) : null" [(ngModel)]="trecho.dataVolta" (dateChange)="setaDataVolta($event.value, busca.trechos, i)"
                      autocomplete="off" [disabled]="!usa_noite_extra_pacote"/>
                  <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                  <mat-datepicker-toggle matSuffix [for]="pickerVolta"></mat-datepicker-toggle>
                  <mat-datepicker #pickerVolta></mat-datepicker>
              </mat-form-field>
            </div>

          </div>

          <div class="room">
            <app-quartos [quartos]="busca.quartos" [modal]="false"></app-quartos>
          </div>
          <div class="input-group mt-4">
            <div *ngIf="semAgencia" class="col-md-12 col-sm-12">
              <div class="alert alert-danger">
                <p>{{ "Selecione uma Agência para continuar" | translate }}</p>
              </div>
            </div>
            <div *ngIf="erros?.length > 0" class="col-md-12 col-sm-12">
              <div class="alert alert-danger" style="width: 100%">
                <ul>
                  <li *ngFor="let mensagem of erros">{{ mensagem }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" [disabled]="desabilitaTarifa" class="btn btn-search"
        (click)="fecharModal(); BuscaPacotes(Pacote);">
        {{"Tarifar Pacote" | translate }}
      </button>
    </div>
  </ng-template>
